import React from "react";
import c from "classnames";

import css from "./block.module.scss";

const IconTextBlock = ({ style, children, iconSrc, className, alt }) => {
  return (
    <div className={c("w-100 mh-100", css["itb-wrapper"], className)} style={style}>
      <div className="row no-gutters">
        <div className="col-4">
          <div className="p-3">
            <img src={iconSrc} className="d-block mx-auto mw-100" alt={alt} />
          </div>
        </div>
        <div className="col-8">
          <div className="p-3">{children}</div>
        </div>
      </div>
    </div>
  );
};

export default IconTextBlock;
